import SecurityService from "../../barrel/services/securityService";

function HxfSafeHtmlContentRender(props:any){

    return(
        <div dangerouslySetInnerHTML={{__html: SecurityService().hxfLabelRendererContentHtmlSanitize(props.children)}}/>
    )
}

export default HxfSafeHtmlContentRender;